<aside class="history-panel" aria-label="Histórico de revisões do contrato">
  <header class="history-panel__header">
    <div>
      <h3>Histórico de revisões</h3>
      <p>Clique numa revisão para ver o texto dela.</p>
    </div>
    <button
      type="button"
      class="history-panel__close"
      pTooltip="Fechar histórico"
      tooltipPosition="left"
      aria-label="Fechar histórico"
      (click)="collapse.emit()">
      <i class="pi pi-angle-double-right"></i>
    </button>
  </header>

  @if (loading()) {
    <app-loading />
  } @else {
    <ol class="history-panel__list">
      @for (revision of revisions(); track revision.id; let first = $first) {
        <li>
          <button
            type="button"
            class="history-panel__item"
            [class.history-panel__item--selected]="selectedId() === revision.id"
            (click)="selectRevision.emit(revision)">
            <span class="history-panel__dot" [class.history-panel__dot--current]="first"></span>
            <span class="history-panel__body">
              <span class="history-panel__title">
                Revisão {{ revision.revisionNumber }} · {{ actionLabel(revision.action) }}
                @if (first) {
                  <span class="history-panel__badge">Atual</span>
                }
              </span>
              <span class="history-panel__meta">
                {{ revision.createdAt | vaultDateTime }}
                @if (revision.createdByName) {
                  · {{ revision.createdByName }}
                }
              </span>
              @if (revision.title) {
                <span class="history-panel__note">{{ revision.title }}</span>
              }
            </span>
          </button>
        </li>
      } @empty {
        <li class="history-panel__empty">{{ emptyRevisionsText() }}</li>
      }
    </ol>

    <h4 class="history-panel__section-title">Alterações de valores</h4>
    <ol class="history-panel__list" aria-label="Alterações de valores do contrato">
      @for (change of fieldChanges(); track $index) {
        <li class="history-panel__change">
          <span class="history-panel__title">
            {{ change.fieldLabel }}: {{ formatValue(change.oldValue, change.fieldKey) }} →
            {{ formatValue(change.newValue, change.fieldKey) }}
          </span>
          <span class="history-panel__meta">
            {{ change.createdAt | vaultDateTime }}
            @if (change.changedByName) {
              · {{ change.changedByName }}
            }
          </span>
          @if (change.defaultValue !== null && change.defaultValue !== undefined) {
            <span class="history-panel__note"
              >Padrão {{ formatValue(change.defaultValue, change.fieldKey) }}</span
            >
          }
        </li>
      } @empty {
        <li class="history-panel__empty">{{ emptyFieldChangesText() }}</li>
      }
    </ol>
  }
</aside>
